import React, { Component } from 'react';
import './PageNotFound.css';
import "../../CommonStyles/CSS.css"
//import dvas from '../../images/public/registeration/dvas.png';
//import clos from '../../images/public/registeration/clos.png';
//import back from '../../images/public/registeration/back.png';
//import Aggiungi from '../../images/public/Aggiungi.png';
//import tick from '../../images/public/tick.png';
//import help from '../../images/public/userarea/tab5u.png';
//import crdscia from '../../images/public/userarea/crdscia.png';
//import stck from '../../images/public/login/stck.png';
//import logo from '../../images/public/login/logo.png';
//import { element } from 'prop-types';
//import classNames from 'classnames';
//import { BrowserView, MobileView, isBrowser, isMobile, isFirefox, isTablet, isMobileOnly, isAndroid, isIOS, browserName } from 'react-device-detect';
//import { Rectangle, Circle, Ellipse, Line, Polyline, CornerBox, Triangle } from 'react-shapes';
//import { RadioGroup, Radio } from 'react-radio-group';
//import { height } from 'window-size';
//import WebFont from 'webfontloader';
//import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
//import Configminore from '../Configminore/Configminore';
import tr from '../../libs/tr'
//import AlertPnl from "../../assets/components/panel/AlertPnl";
//import RadioVerTwo from '../../assets/components/radiobtn/RadioVerTwo'
//import { validateCard } from '../../libs/fetch'
//import WaitLoad from "../../assets/components/loading/WaitLoad";
//import Cookies from 'universal-cookie';
//import { Button, Container, Row, Col, Modal, Spinner } from 'react-bootstrap';
//import { getWorkFlow, modifyWorkflow, workflowState, updateWorkflow, workflowTransition, workflowHelp } from "../../libs/workflow";
//import { HtmlWrapper, fontStyles, getRouteName } from '../../Utils';
//import InfoModal from "../../assets/components/Modal/Modal";

export default class PageNotFound extends Component {
	constructor(props) {
		super(props);
		this.state = {
		};
	}

	render() {
		return (
			<Router>
				<div>
					<div className="sn_overlay d-lg-none"></div>
					<div className="sn_not-found">
						<div className="container">
							<div className="row">       
								<div className="col-12 col-lg-7 mx-auto">
									<div className="sn_register__container p-3 p-lg-5">
										<div className="row">
											<div className="col-12 d-flex align-items-center flex-column">
												<div className="sn_not-found__container__image mb-3">
													<img src={"https://user.mypass.cc/emails/ID25-RENEW-SKI+1.jpg"} className="notfound-image mx-auto" />
												</div>
												<p className="mb-5">{ tr.t("pagenotfound") }</p>
												<button className="sn_btn" onClick={() => { window.location.replace("/") }}>{ tr.t("Goto") }</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</Router>
		)
	}
}


// WEBPACK FOOTER //
// ./src/screens/PageNotFound/PageNotFound.js